/**
 * Case-insensitive comparator factory by object key — ported from
 * apps/vault-frontend/src/features/shared/fileName.ts's `sortByKey` (the only helper from that
 * file the candidate-assignments feature uses; the rest of `fileName.ts` is vault's
 * upload-filename-validation quirks, unrelated to this port).
 */
export function sortByKey<T>(key: keyof T = "label" as keyof T) {
  return (a: T, b: T): number => {
    const av = String(a[key] ?? "").toLowerCase();
    const bv = String(b[key] ?? "").toLowerCase();
    if (av < bv) {
      return -1;
    }
    if (av > bv) {
      return 1;
    }
    return 0;
  };
}
